import { Link } from 'react-router-dom';
import { FaExclamationTriangle, FaHome, FaSearch } from 'react-icons/fa';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';

const NotFound = () => {
  return (
    <>
      <CustomHeader />
      
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 pt-20">
        <div className="max-w-lg w-full text-center">
          <div className="mb-8">
            <FaExclamationTriangle className="text-yellow-500 text-6xl mx-auto mb-6" />
            <h1 className="text-5xl font-bold text-gray-800 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-6">Page Not Found</h2>
            <p className="text-gray-600 mb-8">
              Oops! The page you are looking for doesn't exist or has been moved.
            </p>
          </div>
          
          <div className="mb-8">
            <div className="relative max-w-md mx-auto">
              <input
                type="text"
                placeholder="Search for products, topics..."
                className="w-full px-4 py-3 pl-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
              />
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link 
              to="/" 
              className="flex items-center justify-center gap-2 btn-primary"
            >
              <FaHome /> Back to Home
            </Link>
            <Link 
              to="/products" 
              className="flex items-center justify-center gap-2 btn-secondary"
            >
              Browse Products
            </Link>
          </div>
          
          <div className="mt-12 text-gray-600">
            <p>Need assistance? <Link to="/contact" className="text-primary hover:underline">Contact our support team</Link></p>
          </div>
        </div>
      </div>

      <CustomFooter />
    </>
  );
};

export default NotFound;